import type { CoreUser } from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

export type GetStoreDetailsOptions = {
  availability?: boolean
}

/**
 * Get store details.
 *
 * @endpoint GET /api/stores/{storeDomain}
 * @scope store
 * @see https://flecto.dev/api-4724251
 */
export async function getStoreDetails(
  storeDomain: string,
  options?: GetStoreDetailsOptions
): Promise<CoreUser> {
  const response = await api.get(`/api/stores/${storeDomain}`, {
    params: options,
  })

  const { data } = deserialize<CoreUser>(response.data)

  return data
}
